import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import Opportunities from "../../../components/Alumni/Opportunities";

function OpportunitiesPage(props) {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={11} sm={10} style={{ margin: "0 auto" }}>
          <Opportunities {...props} />
        </Grid>
      </Grid>
    </Aux>
  );
}

export default OpportunitiesPage;
